export default {
    path : "officebuilding-item-pause",
    name : "officebuilding-item-pause",
    meta : {
        title : "暂缓跟进项目"
    },
    component: () => import('@/pages/officebuilding/pause/Index'),
    redirect: {
        name : "officebuilding-item-pause-whole"
    },
    children: [
        {
            path: 'all',
            name: 'officebuilding-item-pause-whole',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'officebuilding-item-pause-recent',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'officebuilding-item-pause-atme',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'officebuilding-item-pause-meat',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'officebuilding-item-pause-reply',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'officebuilding-item-pause-search',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/officebuilding/pauseitem/index.js